export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 shrink-0">
              <i className="ri-mail-send-line text-xl"></i>
            </div>
            <div>
              <h3 className="text-lg font-heading font-bold text-foreground-950">
                联系我们 · 内容投稿
              </h3>
              <p className="text-sm text-foreground-600 mt-1">
                欢迎影视创作者、版权方及追剧爱好者与我们联系。如有优质剧集资源推荐、内容合作或观影反馈，请通过邮件投稿。小草影院致力于为观众提供最新最全的高清电视剧资源，期待与您携手共建优质观影平台。
              </p>
            </div>
          </div>
          <a
            href="mailto:contact@xiaocao.tv"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all shrink-0 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            发送邮件
          </a>
        </div>
      </div>
    </section>
  );
}